import { render, staticRenderFns } from "./PriceDisclaimer.vue?vue&type=template&id=3046b004&"
import script from "./PriceDisclaimer.vue?vue&type=script&lang=js&"
export * from "./PriceDisclaimer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports